export default "__VITE_ASSET__CjGcK1FX__"